enum SurveyFormat {
  CLASSIC = 'CLASSIC',
  OQAAT = 'ONE_QUESTION_AT_A_TIME',
  CONVERSATIONAL = 'CONVERSATIONAL',
}

export default SurveyFormat;
